import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router/router";
import store from "./store/store";

Vue.config.productionTip = false;

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
// import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import Vodal from "vodal";

Vue.component(Vodal.name, Vodal);
import "vodal/common.css";
import "vodal/rotate.css";

import CheckboxRadio from "vue-checkbox-radio";

Vue.use(CheckboxRadio);
import "./filter.js";

import Clipboard from "v-clipboard";
Vue.use(Clipboard);

//multi-select
// import Multiselect from "vue-multiselect";
// Vue.component("multiselect", Multiselect);

//Otp Input
import OTPInput from "@8bu/vue-otp-input";
Vue.use(OTPInput);

import SingleInput from "vue-single-input";
Vue.use(SingleInput);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import Flutterwave from "vue-flutterwave";

Vue.use(Flutterwave, {
  publicKey: "FLWPUBK-47fab7b8f58d7854b7720be4116b33b8-X"
});

import VueFormulate from "@braid/vue-formulate";
import S3FileUploadUtils from "./utils/BaseUtils/S3FileUploadUtils";
Vue.use(VueFormulate, {
  library: {
    autocomplete: {
      classification: "text",
      component: "MyFormulateAutocomplete"
    },
    uploader: async function(file, progress, error) {
      let uploadedImage = await S3FileUploadUtils.uploadFileToS3BucketAsync(
        file,
        S3FileUploadUtils.params.albums.STAGING,
        progress,
        error
      );
      return await uploadedImage;
    }
  }
});

import VueFriendlyIframe from "vue-friendly-iframe";

Vue.use(VueFriendlyIframe);

import vueCountryRegionSelect from "vue-country-region-select";
Vue.use(vueCountryRegionSelect);

import VueLottiePlayer from "vue-lottie-player";
Vue.use(VueLottiePlayer);

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

Vue.component("vue-phone-number-input", VuePhoneNumberInput);

import PortalVue from "portal-vue";

Vue.use(PortalVue);

import vuetify from "@/plugins/vuetify"; // path to vuetify export

import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

// import { library } from '@fortawesome/fontawesome-svg-core'
//
// import { faHatWizard } from '@fortawesome/free-solid-svg-icons'
//
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// library.add(faEye)
// Vue.component('font-awesome-icon', FontAwesomeIcon)

import VueChatScroll from "vue-chat-scroll";
Vue.use(VueChatScroll);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
